import MainScene from "src/app/Scenes/MainScene";
import { PlayerMetadata } from "./PlayerMetadata";
import BaseLevelScene from "src/app/Scenes/BaseLevelScene";
import { DropItem } from "./DropItem";

export class Peer extends Phaser.Physics.Matter.Sprite {

  nameText: Phaser.GameObjects.Text;
  playerName: string;
  lastUpdated: number;
  sound: Phaser.Sound.BaseSound;

  constructor(playerInfo: PlayerMetadata, scene: MainScene | BaseLevelScene, texture: string, frame?: string | number) {
    const { x, y } = playerInfo.playerPosition;
    const { playerName, connectionId } = playerInfo;

    // 1. Create the main sprite with physics enabled
    super(scene.matter.world, 0, 0, 'player', undefined, { isSensor: true,
      label: 'peerSensor'
    });

    this.name = connectionId;
    this.playerName = playerName;
    this.lastUpdated = playerInfo.lastUpdated;

    this.setOrigin(0.5, 0.5);
    this.setFixedRotation();
    this.setDepth(2);
    this.setPosition(x, y);
    this.setScale(scene.playerScale);

    // Add sound for when player is hit
    this.sound = scene.sound.add('playerHit');
    
    // 2. Create the sensor body (circle around the player)
    // const Bodies = new Phaser.Physics.Matter.MatterPhysics(scene).bodies;
    // const sensor = Bodies.circle(x, y, 80, {
    //   isSensor: true,
    //   label: 'peerSensor',
    // });


    // // 3. Combine sprite body and sensor
    // const Body = new Phaser.Physics.Matter.MatterPhysics(scene).body;
    // const compoundBody = Body.create({
    //   parts: [sprite.body as MatterJS.BodyType, sensor],
    //   inertia: Infinity,
    // });

    // // 4. Assign the sensor body to the sprite
    // sprite.setExistingBody(sensor);

    // 5. Add a text label (not part of physics, just floats above)
    this.nameText = scene.add.text(playerInfo.playerPosition.x, playerInfo.playerPosition.y - 40*scene.playerScale, playerName || '???', {
      fontSize: '14px',
      fontFamily: 'Arial',
      color: '#ffffff',
      stroke: '#000000',
      strokeThickness: 2,
    }).setOrigin(0.5, 0.5).setDepth(2).setScale(scene.playerScale);

    // 7. Add this player to the list of other players
    // and to the scene.
    scene.otherPlayers.add(this);
    scene.add.existing(this);
  }

  updatePosition(playerInfo: PlayerMetadata){
        

    // Calculate direction
    const dx = playerInfo.playerPosition.x - this.x;
    const dy = playerInfo.playerPosition.y - this.y;
    let animKey = '';

    if (Math.abs(dx) > Math.abs(dy)) {
      animKey = dx > 0 ? 'walk-right' : 'walk-left';
    } else {
      animKey = dy > 0 ? 'walk-down' : 'walk-up';
    }

    // Play animation if not already playing
    if (!this.anims.isPlaying || this.anims.currentAnim.key !== animKey) {
      this.play(animKey, true);
    }

    // Tween the sprite
    this.scene.tweens.add({
      targets: this,
      x: playerInfo.playerPosition.x,
      y: playerInfo.playerPosition.y,
      ease: 'Linear',
      duration: 100
    });

    // Tween the name tag
    this.scene.tweens.add({
      targets: this.nameText,
      x: playerInfo.playerPosition.x,
      y: playerInfo.playerPosition.y - 40*(this.scene as MainScene | BaseLevelScene).playerScale,
      ease: 'Linear',
      duration: 100
    });
  }

  customDestroy(){
    // Remove all tweens targeting this sprite
    this.scene.tweens.killTweensOf(this);

    // Destroy name text if it exists
    if (this.nameText) {
      this.nameText.destroy();
    }

    // Destroy the sprite itself
    this.destroy();
  }

  flash(color: 'red' | 'green' | 'blue' = 'red') {
    const hexVal = color === 'red' ? 0xff0000 : color === 'green' ? 0x00ff00 : 0x0000FF;
    this.setTint(hexVal);
    setTimeout(() => {
      this.setTint(hexVal);
    }, 250);
    setTimeout(() => {
      this.setTint(0xffffff);
    }, 250);
    setTimeout(() => {
      this.setTint(hexVal);
    }, 250);
    setTimeout(() => {
      this.setTint(0xffffff);
    }, 250);
  }

  hit(){
    this.flash('red');
    this.sound.play('playerHitSound');
  }
}